<template>
  <div class="asc-nested-cell">
    <asc-error-type-icon-label
      :error-type="getErrorType"
    ></asc-error-type-icon-label>
    <v-icon
      v-if="displayIcon && expandIcon"
      class="asc-nested-cell--button"
      size="16"
      color="#000"
      @click="handleArrowClicked"
      >mdi-chevron-down</v-icon
    >
    <v-icon
      v-if="displayIcon && !expandIcon"
      class="asc-nested-cell--button"
      size="16"
      color="#000"
      @click="handleArrowClicked"
      >mdi-chevron-up</v-icon
    >
  </div>
</template>

<script>
import AscErrorTypeIconLabel from '@/components/atoms/AscErrorTypeIconLabel'
export default {
  name: 'AscNestedCell',

  components: {
    AscErrorTypeIconLabel,
  },

  props: {
    params: {
      type: Object,
      default: () => {},
    },
    handleArrowClicked: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    getErrorType() {
      return this.params.data.errorType
    },
    displayIcon() {
      return this.params.data.children?.length
    },
    expandIcon() {
      return !this.params.node.expanded
    },
  },
}
</script>

<style lang="scss">
.asc-nested-cell {
  display: flex;

  &--button {
    justify-content: center;

    &:hover {
      background-color: $accent-200;
      border-radius: 3px;
    }

    &::after {
      background-color: transparent !important;
      border: none !important;
    }
  }

  .asc-error-type-icon-label--container {
    width: 80px;
  }
}
</style>
